import { useEffect } from 'react'

import { roomKeys } from 'helpers/events'

export default function useHandleRoomDisconnectionErrors(room, onError) {
    useEffect(() => {
        const onDisconnected = (room, error) => {
            if (error) {
                onError(error)
            }
        }

        room.addListener(roomKeys.DISCONNECTED, onDisconnected)

        return () => {
            room.removeListener(roomKeys.DISCONNECTED, onDisconnected)
        }
    }, [room, onError])
}
